import(/* webpackMode: "eager" */ "/var/www/node/intl/src/app/error.tsx")